export default __webpack_public_path__ + "static/media/flutictactoe.f95ec102.png";